import SearchInput from 'components/SearchInput';
import ListTabs from 'components/ListTabs';
import ListWrapper from 'components/ListWrapper';
import Typography from 'components/Typography';
import ListActionsWrapper from 'components/ListActionsWrapper';
import DataTable from 'components/DataTable';
import {Address, Order, OrderType, ScriptStatus} from 'types';
import styles from './Requests.module.scss';
import './styles.scss';
import stat_time from '../DeliveryPlanner/icons/stat_time.svg';
import calendar from '../DeliveryPlanner/icons/calendar.svg';
import useRequests from './useRequests';
import Pagination from 'components/Pagination';
import DateTimePicker from 'components/DateTimePicker';
import Select from 'components/Select';
import {components} from 'react-select';
import {groupBy, isArray, map, reject, sortBy as sortLodash} from 'lodash';
import nyPostalCodeBoroughOptions from 'shared/ny-postal-code-borough-options';
import locationIcon from './location.svg';
import Button from 'components/Button';
import Modal from 'components/Modal';
import CreateAddress from 'pages/UserForm/CreateAddressModal';
import {addressToString} from 'helpers/address';
import {NewProduct} from 'pages/Products/Products';
import NewCustomerModal from 'pages/Members/Customers/NewCustomerModal';
import classNames from 'classnames';
import FilterIcon from './FilterIcon';
import Morning from 'pages/DeliveryPlanner/icons/morning';
import Evening from 'pages/DeliveryPlanner/icons/evening';
import Afternoon from 'pages/DeliveryPlanner/icons/afternoon';
import ScriptStatusSelect from 'components/ScriptStatusSelect';
import FormGroup from 'components/FormGroup';
import toast from 'react-hot-toast';
import PlusComponent from 'components/PlusComponent';
import {useCompanyConfig} from 'hooks/useCompanyConfig';
import {Fragment} from 'react/jsx-runtime';
import {
  attemptSelectOptions,
  SYNC_SOURCE_OPTIONS,
} from 'constants/select-options';
import PriorityFlag from 'components/PriorityFlag';
import useAuth from 'hooks/useAuth';
import FeatureGuard from 'components/FeatureGuard';

const locationOptionsGrouped = groupBy(nyPostalCodeBoroughOptions, 'label');
const sorted: {label: string; value: any}[] = map(
  locationOptionsGrouped,
  (obj, key) => ({
    label: key,
    value: map(obj, 'value'),
  })
);
const locationOptions = sortLodash(sorted, 'label');

type Props = {
  source: string;
};

function Requests({source}: Props) {
  const {
    data,
    totalPages,
    dailyCount,
    loading,
    sortBy,
    sortOrder,
    tabs,
    status,
    onSort,
    setStatus,
    keyWord,
    setKeyWord,
    MMtabs,
    location,
    preferenceTime,
    MMTable,
    clients,
    products,
    setProducts,
    services,
    setServices,
    setClients,
    addresses,
    getAddress,
    setAddresses,
    currentPage,
    setCurrentPage,
    params,
    onChangeTab,
    handleNavigateRequest,
    history,
    submitting,
    onSubmit,
    visible,
    setVisible,
    productIds,
    setProductIds,
    serviceIds,
    setServiceIds,
    userId,
    setUserId,
    addressId,
    setAddressId,
    handleClose,
    filter,
    setFilter,
    filterVisible,
    setFilterVisible,
    filtered,
    applyFilter,
    resetFilter,
    isModalOpen,
    setModalOpen,
    addressVisible,
    setAddressVisible,
    productVisible,
    serviceVisible,
    setServiceVisible,
    setProductVisible,
    ORDERS_SCHEME,
    selectedOrders,
    showStatusModal,
    setShowStatusModal,
    orderStatus,
    setOrderStatus,
    statusesData,
    setStatusesData,
    submitOrderStatuses,
    onFilterModalClose,
    handleSelectAttempt,
    landlordSelectOptions,
    propertyAddressOptions,
    propertyNameOptions,
    jobDescription,
    setJobDescription,
    mergeOrders,
    isMerging,
    isSubmittingOrderStatuses,
    selectedOrderType,
    setSelectedOrderType,
  } = useRequests({source});
  const {labels, isDeliveryManager, isPickupDropoff} = useCompanyConfig();
  const {currentUser} = useAuth();
  const isLandlord = currentUser?.role === 'landlord';
  const isSubmittable = isDeliveryManager
    ? !!productIds.length
    : !!serviceIds.length || !!productIds.length;
  const isMergable = selectedOrders.length === 2;

  return (
    <>
      <div className={styles.top_header}>
        <Typography variant="h2">{labels.orders}</Typography>

        <div className={styles.topButtonContainer}>
          <div className={styles.rightButtons}>
            <FeatureGuard feature="hasMergeOrdersOnOrderList">
              {!!selectedOrders.length && (
                <Button
                  disabled={!isMergable || isMerging}
                  color="blue"
                  onClick={mergeOrders}
                  loading={isMerging}
                >
                  {isMerging ? 'Merging...' : 'Merge Orders'}
                </Button>
              )}
            </FeatureGuard>
            {selectedOrders.length > 0 && (
              <Button onClick={() => setShowStatusModal(true)} color="blue">
                Bulk Update
              </Button>
            )}

            <Button
              onClick={async () => {
                if (selectedOrders.length < 1) {
                  toast.error(
                    'Please select one or more orders using the checkboxes.'
                  );
                  return;
                }
                await submitOrderStatuses();
              }}
              color="blue"
              disabled={isSubmittingOrderStatuses}
              loading={isSubmittingOrderStatuses}
            >
              Send to Dispatch
            </Button>

            <Button onClick={() => setVisible(true)}>Add {labels.order}</Button>
          </div>
          <Typography variant="h4">
            Today's {labels.orders}: {dailyCount}
          </Typography>
        </div>
      </div>
      <ListWrapper>
        <ListTabs
          onChange={setStatus}
          isSupportPage={false}
          activeTabValue={status}
          tabs={source === 'micromerchant' ? MMtabs : tabs}
        />
        <ListActionsWrapper>
          <div className={styles.row}>
            <SearchInput
              className={styles.input}
              value={keyWord}
              onChange={(val) => {
                setKeyWord(val.target.value);
                setCurrentPage(1);
                if (params.page !== '1') {
                  if (source === 'app') {
                    history.push('/requests/page/1');
                  } else {
                    history.push('/orders/page/1');
                  }
                }
                sessionStorage.setItem(`searchKey_${source}`, val.target.value);
              }}
              placeholder="Search"
            />
            <div
              className={classNames(
                styles.filterBtn,
                filtered && styles.filterBtnActive
              )}
              onClick={() => setFilterVisible(true)}
            >
              <FilterIcon isFilled={filtered} />
              <span>{filtered ? 'Filtered' : 'Filter'}</span>
            </div>
          </div>
          <div className={styles.preferenceDate}>
            <Select
              className={'Table_Select'}
              isSearchable={false}
              onChange={onChangeTab}
              options={[
                {
                  label: 'Table column',
                  options: ORDERS_SCHEME.slice(1).map((item) => ({
                    ...item,
                    value: item.dataKey,
                    label: item.header,
                  })),
                },
              ]}
              value={MMTable}
              placeholder={
                <span className="select-placeholder-text">Display</span>
              }
              components={{
                Input: () => null,
                DropdownIndicator: (props) =>
                  !preferenceTime ? (
                    <components.DropdownIndicator {...props} />
                  ) : null,
                SingleValue: ({children, ...props}) => {
                  return (
                    <components.SingleValue {...props}>
                      Display
                    </components.SingleValue>
                  );
                },
                IndicatorSeparator: () => null,
              }}
              closeMenuOnSelect={false}
            />
          </div>
        </ListActionsWrapper>
        <DataTable
          schema={MMTable}
          data={data}
          sortBy={sortBy}
          sortOrder={sortOrder}
          onClick={handleNavigateRequest}
          onSort={onSort}
          loading={loading}
        />
        {!loading && (
          <Pagination
            basePath={'/orders'}
            page={currentPage}
            total={totalPages}
            setCurrentPage={setCurrentPage}
          />
        )}
      </ListWrapper>
      <Modal
        isOpen={filterVisible}
        className={styles.filterModal}
        onClose={onFilterModalClose}
        onRequestClose={onFilterModalClose}
      >
        <Typography variant="h2">Filter</Typography>
        <div className={styles.filterContainer}>
          <div className={styles.row}>
            <div style={{width: '100%'}}>
              <Select
                className={'DeliveryPlanner__Filter'}
                placeholder="Location"
                menuPosition="fixed"
                components={{
                  Input: () => null,
                  DropdownIndicator: (props) =>
                    !location ? (
                      <components.DropdownIndicator {...props} />
                    ) : null,
                  Control: ({children, ...props}) => {
                    return (
                      <components.Control {...props}>
                        <img
                          className={styles.locationIcon}
                          src={locationIcon}
                          alt="location_icon"
                        />
                        {children}
                      </components.Control>
                    );
                  },
                  SingleValue: ({children, ...props}) => {
                    return (
                      <components.SingleValue {...props}>
                        {isArray(props.selectProps.value)
                          ? props.selectProps.value
                              .map((item: {label: string}) => item.label)
                              .join(', ')
                          : ''}
                      </components.SingleValue>
                    );
                  },
                  IndicatorSeparator: () => null,
                }}
                isSearchable={false}
                onChange={(data) => {
                  let location: any = [];
                  if (data) {
                    location = filter.location.some(
                      (item: any) => item.label === data.label
                    )
                      ? reject(filter.location, data)
                      : [...filter.location, data];
                  }
                  setFilter((prev: any) => ({
                    ...prev,
                    location,
                  }));
                }}
                isClearable
                options={[
                  {
                    label: 'Locations',
                    options: locationOptions,
                  },
                ]}
                value={filter.location}
              />
            </div>

            <DateTimePicker
              icon={calendar}
              selectsRange={true}
              showTimeSelect={false}
              dateFormat="MM/dd/yy E"
              startDate={filter.createdDate?.start}
              endDate={filter.createdDate?.end}
              placeholder="Created Date"
              className={styles.customInput}
              onChange={(data) => {
                setFilter((prev: any) => ({
                  ...prev,
                  createdDate: {
                    start: data[0] || undefined,
                    end: data[1] || undefined,
                  },
                }));
              }}
            />
          </div>
          <div className={styles.row}>
            <FeatureGuard feature="hasOfferingTypeFilterOnOrders">
              <Select
                className={styles.selectCon}
                isSearchable={false}
                onChange={(val: any) => {
                  setFilter((prev: any) => ({
                    ...prev,
                    onlyOTC: val,
                  }));
                }}
                options={[
                  {label: 'Service', value: 'service'},
                  {label: 'Product', value: 'product'},
                ]}
                value={filter.onlyOTC}
                placeholder={
                  <span className="select-placeholder-text">
                    Service/Product
                  </span>
                }
                isClearable
                components={{
                  Input: () => null,
                  DropdownIndicator: (props) =>
                    !filter.onlyOTC ? (
                      <components.DropdownIndicator {...props} />
                    ) : null,
                  IndicatorSeparator: () => null,
                }}
              />
            </FeatureGuard>
            <Select
              className={styles.selectCon}
              isSearchable={false}
              menuPosition="fixed"
              onChange={handleSelectAttempt}
              options={attemptSelectOptions}
              value={filter.attempt_start}
              placeholder={
                <span className="select-placeholder-text">
                  Redispatch Attempt
                </span>
              }
              isClearable
              components={{
                Input: () => null,
                DropdownIndicator: (props) =>
                  !filter.attempt_start ? (
                    <components.DropdownIndicator {...props} />
                  ) : null,
                IndicatorSeparator: () => null,
              }}
            />
          </div>

          <div className={styles.row}>
            <Select
              className={classNames(styles.selectCon)}
              isSearchable={false}
              menuPosition="fixed"
              onChange={(val: any) => {
                setFilter((prev: any) => ({
                  ...prev,
                  priority: val,
                }));
              }}
              options={[
                {label: 'High', value: 'high'},
                {label: 'Medium', value: 'medium'},
                {label: 'Low', value: 'low'},
              ]}
              value={filter.priority}
              placeholder={
                <span className="select-placeholder-text">Priority</span>
              }
              isClearable
              components={{
                Input: () => null,
                DropdownIndicator: (props) =>
                  !filter.priority ? (
                    <components.DropdownIndicator {...props} />
                  ) : null,
                IndicatorSeparator: () => null,
                SingleValue: (props) => {
                  return (
                    <components.SingleValue
                      {...props}
                      className={styles.select_option}
                    >
                      {props.data.label}
                      <PriorityFlag
                        priority={props.data.value as Order['priority']}
                      />
                    </components.SingleValue>
                  );
                },
                Option: (props) => {
                  return (
                    <components.Option
                      {...props}
                      className={styles.select_option}
                    >
                      {props.data.label}
                      <PriorityFlag
                        priority={props.data.value as Order['priority']}
                      />
                    </components.Option>
                  );
                },
              }}
            />

            <Select
              className={styles.selectCon}
              isSearchable={false}
              menuPosition="fixed"
              onChange={(val: any) => {
                setFilter((prev: any) => ({
                  ...prev,
                  paid: val,
                }));
              }}
              options={[
                {label: 'Paid', value: 'true'},
                {label: 'Unpaid', value: 'false'},
              ]}
              value={filter.paid}
              placeholder={
                <span className="select-placeholder-text">Paid/Unpaid</span>
              }
              isClearable
              components={{
                Input: () => null,
                DropdownIndicator: (props) =>
                  !filter.paid ? (
                    <components.DropdownIndicator {...props} />
                  ) : null,
                IndicatorSeparator: () => null,
              }}
            />
          </div>

          <div className={styles.row}>
            <DateTimePicker
              icon={calendar}
              showTimeSelect={false}
              dateFormat="MM/dd/yy E"
              value={filter.date}
              placeholder="Preference Date"
              className={styles.customInput}
              onChange={(data) => {
                setFilter((prev: any) => ({
                  ...prev,
                  date: data,
                }));
              }}
            />

            <Select
              className={styles.selectCon}
              isSearchable={false}
              menuPosition="fixed"
              onChange={(val: any) => {
                setFilter((prev: any) => ({
                  ...prev,
                  preferenceTime: val,
                }));
              }}
              options={[
                {label: 'Morning', value: 'morning'},
                {label: 'Afternoon', value: 'afternoon'},
                {label: 'Evening', value: 'evening'},
              ]}
              value={filter.preferenceTime}
              placeholder={
                <span className="select-placeholder-text">Preference Time</span>
              }
              isClearable
              components={{
                Input: () => null,
                DropdownIndicator: (props) =>
                  !filter.preferenceTime ? (
                    <components.DropdownIndicator {...props} />
                  ) : null,
                Control: ({children, ...props}) => (
                  <components.Control {...props}>
                    <img
                      className={styles.timeIcon}
                      src={stat_time}
                      alt="timer"
                    />
                    {children}
                  </components.Control>
                ),

                IndicatorSeparator: () => null,
                Option: (props) => {
                  const icons = {
                    morning: <Morning />,
                    afternoon: <Afternoon />,
                    evening: <Evening />,
                  };
                  return (
                    <components.Option
                      {...props}
                      className={styles.select_option}
                    >
                      {props.data.label}
                      {icons[props.data.value as keyof typeof icons]}
                    </components.Option>
                  );
                },
              }}
            />
          </div>
          <FeatureGuard feature="hasLandlordFilterOnOrders">
            {!isLandlord && (
              <div className={styles.row}>
                <Select
                  className={styles.selectCon}
                  isSearchable={false}
                  menuPosition="fixed"
                  onChange={(val: any) => {
                    setFilter((prev: any) => ({
                      ...prev,
                      landlord: val,
                    }));
                  }}
                  options={landlordSelectOptions as any}
                  value={filter.landlord}
                  placeholder={
                    <span className="select-placeholder-text">
                      {labels.landlord}
                    </span>
                  }
                  isClearable
                  components={{
                    Input: () => null,
                    DropdownIndicator: (props) =>
                      !filter.landlord ? (
                        <components.DropdownIndicator {...props} />
                      ) : null,
                    IndicatorSeparator: () => null,
                  }}
                />
                <Select
                  className={styles.selectCon}
                  isSearchable={false}
                  menuPosition="fixed"
                  onChange={(val: any) => {
                    setFilter((prev: any) => ({
                      ...prev,
                      property_name: val,
                    }));
                  }}
                  options={propertyNameOptions as any}
                  value={filter.property_name}
                  placeholder={
                    <span className="select-placeholder-text">
                      {labels.property}&nbsp;Name
                    </span>
                  }
                  isClearable
                  components={{
                    Input: () => null,
                    DropdownIndicator: (props) =>
                      !filter.property_name ? (
                        <components.DropdownIndicator {...props} />
                      ) : null,
                    IndicatorSeparator: () => null,
                  }}
                />
              </div>
            )}
          </FeatureGuard>
          <FeatureGuard feature="hasPropertyAddressFilterOnOrders">
            <div className={styles.row}>
              {!isLandlord && (
                <Select
                  className={styles.selectCon}
                  isSearchable={false}
                  menuPosition="fixed"
                  onChange={(val: any) => {
                    setFilter((prev: any) => ({
                      ...prev,
                      property_address: val,
                    }));
                  }}
                  options={propertyAddressOptions as any}
                  value={filter.property_address}
                  placeholder={
                    <span className="select-placeholder-text">
                      {labels.property}&nbsp;Address
                    </span>
                  }
                  isClearable
                  components={{
                    Input: () => null,
                    DropdownIndicator: (props) =>
                      !filter.paid ? (
                        <components.DropdownIndicator {...props} />
                      ) : null,
                    IndicatorSeparator: () => null,
                  }}
                />
              )}
            </div>
          </FeatureGuard>
          <div className={styles.row}>
            <Select
              className={styles.selectCon}
              isSearchable={false}
              menuPosition="fixed"
              onChange={(val: any) => {
                setFilter((prev: any) => ({
                  ...prev,
                  sync_source: val,
                }));
              }}
              options={SYNC_SOURCE_OPTIONS}
              value={filter.sync_source}
              placeholder={
                <span className="select-placeholder-text">Sync Source</span>
              }
              isClearable
              components={{
                Input: () => null,
                DropdownIndicator: (props) =>
                  !filter.sync_source ? (
                    <components.DropdownIndicator {...props} />
                  ) : null,
                IndicatorSeparator: () => null,
              }}
            />
          </div>
        </div>
        <div className={styles.filterBtnContainer}>
          <Button onClick={resetFilter} color="gray">
            Reset
          </Button>
          <Button onClick={applyFilter}>Apply</Button>
        </div>
      </Modal>
      <Modal
        isOpen={visible}
        onClose={handleClose}
        className={styles.list_wrapper}
        onRequestClose={handleClose}
      >
        <Typography variant="h2">Add New {labels.order}</Typography>

        <FeatureGuard feature="hasOrderTypeSelectOnOrderCreation">
          <div className={styles.label}>
            <div>Order Type</div>
          </div>
          <Select
            placeholder="Click To Select"
            onChange={(item) => {
              setSelectedOrderType(item?.value as OrderType);
            }}
            value={
              selectedOrderType
                ? {
                    value: selectedOrderType,
                    label:
                      selectedOrderType === 'dropoff'
                        ? 'Customer Order'
                        : 'Purchase Order',
                  }
                : undefined
            }
            menuPosition="fixed"
            options={[
              {label: 'Customer Order', value: 'dropoff'},
              {label: 'Purchase Order', value: 'pickup'},
            ]}
          />
        </FeatureGuard>
        {(isPickupDropoff && selectedOrderType) || !isPickupDropoff ? (
          <Fragment>
            <div className={styles.label}>
              <div>
                {selectedOrderType === 'pickup' ? 'Vendor' : 'Customer'}
              </div>
              <PlusComponent onClick={() => setModalOpen(true)} />
            </div>

            <Select
              placeholder="Click To Select"
              onChange={(item) => {
                setUserId(item?.value);
                getAddress(Number(item?.value));
              }}
              value={
                clients.find((item) => item.id === userId)
                  ? {
                      value:
                        clients.find((item) => item.id === userId)?.user?.id ||
                        '',
                      label:
                        clients.find((item) => item.id === userId)?.user
                          ?.first_name +
                        ' ' +
                        clients.find((item) => item.id === userId)?.user
                          ?.last_name,
                    }
                  : undefined
              }
              menuPosition="fixed"
              options={clients
                .filter(
                  (client) =>
                    client.client_role ===
                    (selectedOrderType === 'pickup' ? 'vendors' : 'customers')
                )
                .map((item) => ({
                  value: item.id,
                  label: item.user.first_name + ' ' + item.user.last_name,
                }))}
            />
          </Fragment>
        ) : null}
        {userId !== 0 && (
          <>
            <div className={styles.label}>
              <div>Address</div>
              <PlusComponent onClick={() => setAddressVisible(true)} />
            </div>

            <Select
              placeholder="Click To Select"
              menuPosition="fixed"
              onChange={(item) => {
                setAddressId(item?.value);
              }}
              value={
                addresses.find((item) => item.id === addressId)
                  ? {
                      value:
                        addresses.find((item) => item.id === addressId)?.id ||
                        '',
                      label: addressToString(
                        addresses.find(
                          (item) => item.id === addressId
                        ) as Address
                      ),
                    }
                  : undefined
              }
              options={addresses.map((item) => ({
                value: item.id,
                label:
                  item.address_line_1 +
                  ',' +
                  item.city +
                  ',' +
                  item.state +
                  ',' +
                  item.zipcode,
              }))}
            />
          </>
        )}
        <FeatureGuard feature="hasServiceOnOrderCreation">
          <Fragment>
            <div className={styles.label}>
              <div>Service</div>
              <PlusComponent onClick={() => setServiceVisible(true)} />
            </div>
            <Select
              placeholder="Click To Select"
              menuPosition="fixed"
              onChange={(item) => {
                if (isArray(item)) {
                  setServiceIds(item?.map((item) => item.value));
                }
              }}
              value={
                serviceIds.length > 0
                  ? services
                      .filter((item) => serviceIds.includes(item.id))
                      .map((item) => ({
                        value: item.id,
                        label: item.name,
                      }))
                  : undefined
              }
              isSearchable={true}
              // @ts-ignore
              isMulti={true}
              options={services.map((item) => ({
                value: item.id,
                label: item.name,
              }))}
            />
          </Fragment>
        </FeatureGuard>

        <div className={styles.label}>
          <div>Product</div>
          <PlusComponent onClick={() => setProductVisible(true)} />
        </div>
        <Select
          placeholder="Click To Select"
          menuPosition="fixed"
          onChange={(item) => {
            if (isArray(item)) {
              setProductIds(item?.map((item) => item.value));
            }
          }}
          value={
            productIds.length > 0
              ? products
                  .filter((item) => productIds.includes(item.id))
                  .map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))
              : undefined
          }
          isSearchable={true}
          // @ts-ignore
          isMulti={true}
          options={products.map((item) => ({
            value: item.id,
            label: item.name,
          }))}
        />

        <FeatureGuard feature="hasJobDescriptionOnOrderCreation">
          <div className={styles.label}>
            <div>Job Description (Optional)</div>
          </div>
          <textarea
            className={styles.messageTextarea}
            placeholder="Enter your job description here"
            rows={4}
            value={jobDescription}
            onChange={(e) => setJobDescription(e.target.value as string)}
          />
        </FeatureGuard>
        <Button
          loading={submitting}
          disabled={!addressId || !userId || !isSubmittable}
          className={styles.addBtn}
          onClick={onSubmit}
        >
          Add {labels.order}
        </Button>
        <NewCustomerModal
          showAdditionalPhoneFields={true}
          onSuccess={(data) => {
            setClients((pr) => [data, ...pr]);
            setUserId(data.id);
          }}
          defaultClientRole="customers"
          isOpen={isModalOpen}
          onClose={() => setModalOpen(false)}
        />

        <CreateAddress
          newAddressType="dispatch"
          customer_id={userId}
          handleClose={() => setAddressVisible(false)}
          onSuccess={(data) => {
            setAddresses((pr) => [data, ...pr]);
            setAddressId(data.id);
          }}
          isOpen={addressVisible}
        />
        <NewProduct
          isTypeDisabled
          productType="product"
          visible={productVisible}
          onClose={() => setProductVisible(false)}
          onSuccess={(data) => {
            setProducts((pr) => [data, ...pr]);
            setProductIds([data.id]);
          }}
        />
        {!isDeliveryManager && (
          <NewProduct
            isTypeDisabled
            productType="service"
            visible={serviceVisible}
            onClose={() => setServiceVisible(false)}
            onSuccess={(data) => {
              setServices((pr) => [data, ...pr]);
              setServiceIds([data.id]);
            }}
          />
        )}
      </Modal>
      <Modal
        isOpen={showStatusModal}
        onRequestClose={() => setShowStatusModal(false)}
        onClose={() => setShowStatusModal(false)}
        className={styles.status_wrapper}
      >
        <div className={styles.times}>
          <FormGroup columns={2}>
            <div style={{flex: 1}}>
              <div className={styles.label}>Status:</div>
              <ScriptStatusSelect
                name={'status'}
                status={orderStatus as ScriptStatus}
                onChange={(val) => setOrderStatus(val?.value || '')}
                type="prescription"
                origin={'micromerchant'}
                isPvfr={true}
                menuPosition="fixed"
                classNamePrefix={'order_select'}
                className={orderStatus || 'default_selected'}
              />
            </div>
            <div style={{flex: 1}}>
              <div className={styles.label}>Priority:</div>
              <Select
                placeholder="Select Priority"
                onChange={(data) => {
                  setStatusesData((pr) => ({
                    ...pr,
                    priority: String(data?.value || ''),
                  }));
                }}
                defaultValue={
                  statusesData.priority
                    ? {
                        value: statusesData.priority,
                        label:
                          statusesData.priority[0].toUpperCase() +
                          statusesData.priority.slice(1),
                      }
                    : undefined
                }
                options={[
                  {
                    label: 'High',
                    value: 'high',
                  },
                  {
                    label: 'Medium',
                    value: 'medium',
                  },
                  {
                    label: 'Low',
                    value: 'low',
                  },
                ]}
                isClearable
                components={{
                  DropdownIndicator: (props) =>
                    !statusesData.priority ? (
                      <components.DropdownIndicator {...props} />
                    ) : null,
                  Option: (props) => {
                    const colors = {
                      high: '#FF0000',
                      medium: '#FFA500',
                      low: '#1A6AE5',
                    };
                    return (
                      <components.Option
                        {...props}
                        className={styles.select_option}
                      >
                        {props.data.label}
                        <div
                          className={styles.priorityColor}
                          style={{
                            backgroundColor:
                              colors[props.data.value as keyof typeof colors],
                          }}
                        ></div>
                      </components.Option>
                    );
                  },
                }}
              />
            </div>
          </FormGroup>
          <FormGroup columns={2}>
            <div style={{flex: 1}}>
              <div className={styles.label}>Preference Date:</div>
              <div className={styles.calendarRoot}>
                <DateTimePicker
                  showTimeSelect={false}
                  dateFormat="MM/dd/yy E"
                  value={
                    statusesData.preference_date
                      ? statusesData.preference_date
                      : undefined
                  }
                  placeholder="Select Date"
                  onChange={(date) => {
                    setStatusesData((pr) => ({
                      ...pr,
                      preference_date: date ? date : null,
                    }));
                  }}
                />
              </div>
            </div>
            <div style={{flex: 1}}>
              <div className={styles.label}>Preference Time:</div>
              <Select
                className={styles.select}
                onChange={(time) => {
                  setStatusesData((pr) => ({
                    ...pr,
                    preference_time: String(time?.value || ''),
                  }));
                }}
                placeholder={
                  <span className="select-placeholder-text">Select Time</span>
                }
                isClearable
                components={{
                  DropdownIndicator: (props) =>
                    !statusesData.preference_time ? (
                      <components.DropdownIndicator {...props} />
                    ) : null,
                  Option: (props) => {
                    const icons = {
                      morning: <Morning />,
                      afternoon: <Afternoon />,
                      evening: <Evening />,
                    };
                    return (
                      <components.Option
                        {...props}
                        className={styles.select_option}
                      >
                        {props.data.label}
                        {icons[props.data.value as keyof typeof icons]}
                      </components.Option>
                    );
                  },
                }}
                value={
                  statusesData.preference_time
                    ? {
                        value: statusesData.preference_time,
                        label:
                          statusesData.preference_time[0].toUpperCase() +
                          statusesData.preference_time.slice(1),
                      }
                    : null
                }
                options={[
                  {value: 'morning', label: 'Morning'},
                  {value: 'afternoon', label: 'Afternoon'},
                  {value: 'evening', label: 'Evening'},
                ]}
                size="md"
              />
            </div>
          </FormGroup>
        </div>
        <div className={styles.actions}>
          <Button
            type="submit"
            color="blue"
            disabled={!orderStatus || isSubmittingOrderStatuses}
            loading={isSubmittingOrderStatuses}
            onClick={submitOrderStatuses}
            size="md"
          >
            Save
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default Requests;
